
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/news",
      function () {
        return require("private-next-pages/destinations/news.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/news"])
      });
    }
  